import { Link, useParams } from "react-router-dom";
import { ARTICLES, findArticle } from "../lib/articles";
import styles from "./Articles.module.css";

export default function Articles() {
  const { slug } = useParams();
  if (!slug) return <ArticlesIndex />;
  const article = findArticle(slug);
  if (!article) {
    return (
      <div className={styles.page}>
        <h1>Article not found</h1>
        <p><Link to="/articles" className={styles.link}>Back to all articles →</Link></p>
      </div>
    );
  }
  return <ArticleView article={article} />;
}

function ArticlesIndex() {
  return (
    <div className={styles.page}>
      <header className={styles.indexHead}>
        <span className={styles.eyebrow}>Articles</span>
        <h1 className={styles.indexTitle}>Field guides &amp; how-tos</h1>
      </header>
      <div className={styles.cards}>
        {ARTICLES.map((a) => (
          <Link key={a.slug} to={`/articles/${a.slug}`} className={styles.card}>
            <span className={styles.cardEyebrow}>{a.eyebrow}</span>
            <h2 className={styles.cardTitle}>{a.title}</h2>
            <p className={styles.cardSummary}>{a.summary}</p>
            <span className={styles.cardCta}>Read article →</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

function ArticleView({ article }) {
  return (
    <article className={styles.page}>
      <Link to="/articles" className={styles.crumb}>← All articles</Link>
      <header className={styles.head}>
        <span className={styles.eyebrow}>{article.eyebrow}</span>
        <h1 className={styles.title}>{article.title}</h1>
        <p className={styles.summary}>{article.summary}</p>
      </header>

      <div className={styles.body}>
        {article.sections?.map((s, i) => (
          <Section key={i} section={s} />
        ))}

        {article.tips?.length > 0 && (
          <section className={styles.tips}>
            <h2 className={styles.tipsTitle}>Pro tips</h2>
            <ul>
              {article.tips.map((t, i) => <li key={i}>{t}</li>)}
            </ul>
          </section>
        )}
      </div>
    </article>
  );
}

function Section({ section }) {
  if (section.kind === "step") {
    return (
      <section className={styles.step}>
        <div className={styles.stepNum}>{String(section.number).padStart(2, "0")}</div>
        <div className={styles.stepBody}>
          <h2 className={styles.stepTitle}>{section.title}</h2>
          <p className={styles.stepText}>{section.body}</p>
          {section.callout && (
            <div className={styles.callout}>{section.callout}</div>
          )}
          {section.sizeChart && (
            <table className={styles.sizeChart}>
              <thead>
                <tr><th>Size</th><th>Torso</th><th>Metric</th></tr>
              </thead>
              <tbody>
                {section.sizeChart.map((r) => (
                  <tr key={r.size}>
                    <td><strong>{r.size}</strong></td>
                    <td>{r.range}</td>
                    <td>{r.cm}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </section>
    );
  }
  return null;
}
